import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class ModelVrmElement extends AbstractBlock {
  constructor() {
    super('vrm_element_v2', t.to('VRMモデル', 'vrm_model'));
  }
  // vrm
  defineBlock(block: BlockType): void {
    ShapeSettings.setElementShape(block);
    ColorSettings.setObjectColor(block);

    ShapeSettings.setTitleField(block, this.title);
    const nameField = new Blockly.FieldTextInput('');
    block
      .appendDummyInput()
      .appendField(`${t.to('名前', 'name')}:`)
      .appendField(nameField, 'nameField');

    // // サムネイルURL
    // let thumbnailField = new Blockly.FieldImage("",width,height,alt,onclick_func,opt_flipRtl,opt_config);
    // thumbnailField.setVisible(false);
    // block.appendDummyInput().appendField(thumbnailField, "thumbnailField");

    const fieldText = new Blockly.FieldTextInput('');
    // fieldText.setVisible(false);
    block.appendDummyInput().appendField(`URL:`).appendField(fieldText, 'src');

    block.appendDummyInput().appendField(`${t.to('位置', 'position')}:`);
    ShapeSettings.setVR3Fields(block, 'position', 0, 0, 0);

    ShapeSettings.addAttributeInput(block);
  }

  // generateAssetsHTMLCode(block: BlockType): string {
  //   const src = CodeSetting.getFieldValue(block, 'src');
  //   const html = `<a-asset-item id="${encodeURI(block.id)}" src="..${src}"></a-asset-item>`;
  //   return html;
  // }

  codeGenerateCore(block: BlockType): string {
    let attribute = CodeSetting.getSubAttributeCode(block);
    const src = CodeSetting.getFieldValue(block, 'src');
    attribute += CodeSetting.getVR3FieldValues(block, 'position');
    // lookAt:#rigしたらネットワーク属性つけられない
    attribute += CodeSetting.getAttributeCode('vrm', `src:..${src};blink:true;`);
    encodeURI(block.id);
    attribute += CodeSetting.getAttributeCode('vrm-anim-default', '');
    const str = CodeSetting.getElementCode('a-entity', attribute, block.id, '');
    return str;
  }
}
